import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { getProductJson } from "@shopify/theme-product";
import CartUpsellItem from "./CartUpsellItem";
import LoadingSpinner from "../../../parts/LoadingSpinner";
import Flickity from "react-flickity-component";

const CartUpsell = ({ collection, cartItems, cartTotal, cardLayout }) => {
  const ctx = window.theme_app;

  const [isLoading, setIsLoading] = useState(true);
  const [collectionProducts, setCollectionProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);
  const freeShippingThreshold = window.theme.freeShippingThreshold;

  const sliderRef = useRef(null);
  console.log("cart upsell loaded")
  const fetchCollectionProducts = async () => {
    const { data } = await axios.get(
      `/collections/${collection}/products.json`
    );
    return data.products;
  };

  const fetchProductsData = async (data) => {
    const products = [];
    for (let p of data) {
      const response = await getProductJson(p.handle);

      products.push(response);
    }
    setCollectionProducts(products);
  };

  useEffect(() => {
    fetchCollectionProducts().then((data) => fetchProductsData(data));
    ctx.on("CartUpsellProductsLoaded", () => {
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (collectionProducts) {
      const updatedProductsArray = [];
      collectionProducts.forEach((p) => {
        const isInCart = cartItems.find((i) => i.product_id == p.id);
        if (!isInCart) {
          updatedProductsArray.push(p);
        }
      });
      setFilteredProducts(updatedProductsArray);
    }
  }, [cartItems, collectionProducts]);

  const flickityOptions = {
    draggable: true,
    contain: true,
    cellAlign: "left",
    groupCells: true,
    prevNextButtons: false,
    pageDots: true,
  };
  const renderHeading = () => {
    const merchProdsInCart =
      collectionProducts?.length - filteredProducts?.length;
    //IF ONLY PRODUCTS FROM UPSELL COLLECTION
    // if (cartItems.length == merchProdsInCart) {
    //   if (cartTotal < freeShippingThreshold) {
    //     return "Often Bought Together"
    //   } else {
    //     return "Add Now For Free Shipping"
    //   }
    // } else { //ELSE IF ANY PRODUCTS IN CART
    //   if (cartTotal < freeShippingThreshold) {
    //     return "Often Bought Together"
    //   } else {
    //     return "Add Now For Free Shipping"
    //   }
    // }
    return "What We Are Loving";
  };

  return (
    <div className="Section Section--cart-upsell">
      {isLoading && <LoadingSpinner></LoadingSpinner>}

      <div
        className="Section__header"
        style={isLoading ? { visibility: "hidden" } : null}
      >
        <h6 className="heading">{renderHeading()}</h6>
      </div>
      <div className="Section__content">
        <Flickity
          className={"Slider Slider--cart-upsell"}
          flickityRef={(c) => (sliderRef.current = c)}
          options={flickityOptions}
          reloadOnUpdate={true}
        >
          {filteredProducts?.map((product) => (
            <CartUpsellItem
              key={product.id}
              product={product}
              layout={cardLayout}
              slider={sliderRef.current}
            />
          ))}
        </Flickity>
      </div>
    </div>
  );
};
export default CartUpsell;
